import { render, staticRenderFns } from "./NoRegion.vue?vue&type=template&id=4d926aba&scoped=true&"
var script = {}
import style0 from "./NoRegion.vue?vue&type=style&index=0&id=4d926aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d926aba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d926aba')) {
      api.createRecord('4d926aba', component.options)
    } else {
      api.reload('4d926aba', component.options)
    }
    module.hot.accept("./NoRegion.vue?vue&type=template&id=4d926aba&scoped=true&", function () {
      api.rerender('4d926aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/NoRegion.vue"
export default component.exports